/**
 * Whether the envelope page offers a new link for somebody: they have a link
 * to replace, their part is not finished, and the envelope is still out for
 * signature.
 *
 * The last was missing. A completed, declined or withdrawn envelope still
 * offered "Reissue link" to anybody whose own part was open, and a withdrawn
 * one minted a working link to a document its sender had taken back. The
 * server now refuses that with 409 envelope_closed (Z-server, 32de4a3); the
 * page does not offer what the server refuses.
 */
export function canReissue(
  p: { link?: unknown },
  partClosed: boolean,
  envelopeStatus: string,
): boolean {
  return envelopeStatus === 'sent' && Boolean(p.link) && !partClosed
}
